var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-wrapper miv-modal-wrapper",class:{ black: _vm.black },on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.closeModal.apply(null, arguments)}}},[_c('transition',{attrs:{"name":"modal","appear":""}},[_c('div',{staticClass:"modal",class:_vm.classes},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }